import React from 'react';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';
import MuiButton from '@material-ui/core/Button';
import MuiGrid from '@material-ui/core/Grid';
import MuiHidden from '@material-ui/core/Hidden';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiMenuIcon from '@material-ui/icons/Menu';
import MuiToolbar from '@material-ui/core/Toolbar';
import MuiTypography from '@material-ui/core/Typography';

import { useAuth0 } from 'utils/auth0';

const lightColor = 'rgba(255, 255, 255, 0.7)';

const styles = theme => ({
  primaryBar: {
    backgroundColor: theme.palette.primary.dark,
  },
  secondaryBar: {
    zIndex: 0,
  },
  menuButton: {
    marginLeft: -theme.spacing(0.5),
  },
  iconButtonAvatar: {
    padding: 4,
  },
  link: {
    textDecoration: 'none',
    color: lightColor,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  button: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.common.white,
    },
  },
  title: {
    flexGrow: 1,
  },
});

function Header(props) {
  const { classes, onDrawerToggle } = props;

  const { user, logout } = useAuth0();

  return (
    <React.Fragment>
      <MuiAppBar className={classes.primaryBar} color="primary" position="sticky" elevation={4}>
        <MuiToolbar>
          <MuiGrid container spacing={1} alignItems="center">
            <MuiHidden mdUp>
              <MuiGrid item>
                <MuiIconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onDrawerToggle}
                  className={classes.menuButton}>
                  <MuiMenuIcon />
                </MuiIconButton>
              </MuiGrid>
            </MuiHidden>
            <MuiTypography variant="h6" className={classes.title}>
              Venice Suite
            </MuiTypography>
            <MuiGrid item xs />
            <MuiGrid item>
              <MuiTypography variant="body2">
                <MuiHidden smDown>Signed in as {user.email}</MuiHidden>
              </MuiTypography>
            </MuiGrid>
            <MuiGrid item>
              {/*
              <MuiLink className={classes.link} href="#" variant="body2">
                Go to docs
              </MuiLink>
              */}
              <MuiButton onClick={logout} className={classes.button} variant="outlined" color="inherit" size="small">
                Sign Out
              </MuiButton>
            </MuiGrid>
            {/*
            <MuiGrid item>
              <MuiTooltip title="Alerts • No alerts">
                <MuiIconButton color="inherit">
                  <MuiNotificationsIcon />
                </MuiIconButton>
              </MuiTooltip>
            </MuiGrid>
            <MuiGrid item>
              <MuiIconButton color="inherit" className={classes.iconButtonAvatar}>
                <MuiAvatar src="/static/images/avatar/1.jpg" alt="My MuiAvatar" />
              </MuiIconButton>
            </MuiGrid>
            */}
          </MuiGrid>
        </MuiToolbar>
      </MuiAppBar>
      {/*
      <MuiAppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="static"
        elevation={0}
      >
        <MuiToolbar>
          <MuiGrid container alignItems="center" spacing={1}>
            <MuiGrid item xs>
              <MuiTypography color="inherit" variant="h5" component="h1">
                Home
              </MuiTypography>
            </MuiGrid>
            <MuiGrid item>
              <MuiButton className={classes.button} variant="outlined" color="inherit" size="small">
                Web setup
              </MuiButton>
            </MuiGrid>
            <MuiGrid item>
              <MuiTooltip title="Help">
                <MuiIconButton color="inherit">
                  <MuiHelpIcon />
                </MuiIconButton>
              </MuiTooltip>
            </MuiGrid>
          </MuiGrid>
        </MuiToolbar>
      </MuiAppBar>
      */}
      {/*
      <MuiAppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="static"
        elevation={0}
      >
        <MuiTabs value={0} textColor="inherit">
          <MuiTab textColor="inherit" label="Users" />
          <MuiTab textColor="inherit" label="Sign-in method" />
          <MuiTab textColor="inherit" label="Templates" />
          <MuiTab textColor="inherit" label="Usage" />
        </MuiTabs>
      </MuiAppBar>
      */}
    </React.Fragment>
  );
}

export default withStyles(styles)(withRouter(Header));
